import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from 'src/app/components/button/button.component';
import { InputWrapperComponent } from 'src/app/shared/components/input-wrapper/input-wrapper.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { FilterFieldNames, ListFilterService } from '../services/list-filter.service';
import { InputRegexDirective } from 'src/app/shared/directives/input-regex.directive';

@Component({
  selector: 'app-advanced-filters',
  templateUrl: './advanced-filters.component.html',
  styleUrls: ['./advanced-filters.component.scss'],
  imports: [
    ButtonComponent,
    InputWrapperComponent,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    InputRegexDirective
],
})
export class AdvancedFiltersComponent implements OnInit {
  @Input() buttonsDisabled = false;
  @Input() showFilters = false;

  filterForm?: FormGroup;

  constructor(private readonly filterService: ListFilterService) {}

  ngOnInit() {
    this.filterForm = this.filterService.getForm();
  }

  handleSubmitFilters() {
    if (this.filterForm?.valid) {
      this.filterService.applyFilters();
    }
  }

  handleClearFilters() {
    this.filterService.clearFilters();
  }

  clearFormControl(fieldName: FilterFieldNames): void {
    const control = this.filterForm?.get(fieldName);
    if (control) {
      control.reset();
    }
  }

  getFieldInfo(fieldName: FilterFieldNames) {
    return {
      title: this.getInfoTitleByName(fieldName),
      info: this.getInfoLabelByName(fieldName),
      invalid: this.isFilterInvalid(fieldName),
    };
  }

  isFilterInvalid(fieldName: FilterFieldNames): boolean {
    const control = this.filterForm?.get(fieldName);
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }

  getInfoLabelByName(fieldName: FilterFieldNames): string {
    const fieldError = this.getFieldError(fieldName);

    if (fieldError) {
      return fieldError;
    }

    const infoLabels: Partial<{ [key in FilterFieldNames]: string }> = {
      dateRange: $localize`DD/MM/AAAA - DD/MM/AAAA`,
      scoreRange: '0 - 1000',
    };

    return infoLabels[fieldName] || '';
  }

  getInfoTitleByName(fieldName: FilterFieldNames): string {
    const titleLabels: { [key in FilterFieldNames]: string } = {
      document: $localize`:@@label_document:Documento`,
      name: $localize`:@@label_name:Nombre`,
      segment: $localize`:@@segment:Segmento`,
      internalCode: $localize`:@@internalCode2:Código Interno`,
      dateRange: $localize`:@@inclusionDate:Fecha de inclusión`,
      scoreRange: $localize`:@@individualScore:Score`,
      restrictivesRange: $localize`:@@restrictiveQuantity:Cantidad de restrictivas`,
    };

    return titleLabels[fieldName] || '';
  }

  getFieldError(fieldName: FilterFieldNames): string | null {
    const control = this.filterForm?.get(fieldName);
    if (control && control.invalid && control.errors && (control.dirty || control.touched)) {
      return Object.values(control.errors)?.[0];
    }
    return null;
  }

  get internalCodeInputPlaceholder() {
    return $localize`:@@search_by_internal_code:Buscar por código interno`;
  }

  get segmentInputPlaceholder() {
    return $localize`:@@search_by_segment:Buscar por segmento`;
  }
}
